import React, { useRef, useEffect } from 'react';
import { CustomBlockProps } from '@/components/editor/Editor';

export const DialogSectionBlock: React.FC<CustomBlockProps> = ({
  id,
  block,
  isActive,
  onUpdate,
  onFocus,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isActive && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isActive]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate(id, { content: e.target.value });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // Let the editor handle creating a new block
    }
  };

  return (
    <div 
      className="my-6 py-4 flex items-center justify-left cursor-text"
      onClick={() => onFocus(id)}
    >
      <div className="flex items-center gap-3 text-purple-600">
 
        <input
          ref={inputRef}
          type="text"
          value={block.content || ''}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onFocus={() => onFocus(id)}
          placeholder="Section Title"
          className="text-left font-bold uppercase tracking-wider text-lg bg-transparent border-none outline-none focus:ring-0 text-purple-600 placeholder-purple-300 min-w-[200px]"
          style={{ width: `${Math.max(200, (block.content?.length || 0) * 12)}px` }}
        />

      </div>
    </div>
  );
};

